import * as React from 'react'

interface Props {
  label?: string
  labels?: string[]
  value?: string | number
  values?: string[] | number[]
  bold?: boolean
  className?: string
  style?: React.CSSProperties
}

const Component: React.FC<Props> = ({ label, labels, value, values, bold, className, style }) => {
  const labelContents = [label, ...(labels ?? [])].filter(Boolean)
  const valueContents = [value, ...(values ?? [])].filter(Boolean)
  return (
    <div className={`mt-4 ${className ?? ''}`} style={style}>
      <div className={`${bold ? 'fw-bold ' : ''}font-15`}>
        {labelContents.map((content, index) => (
          <div key={index}>{content}</div>
        ))}
      </div>
      <div className="mt-2 mb-3" style={{ minHeight: '1.5rem' }}>
        {valueContents.map((content, index) => (
          <div key={index}>{content}</div>
        ))}
      </div>
      <hr />
    </div>
  )
}

export default Component
